function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesLockerFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2a2 2 0 00-2 2v24a2 2 0 002 2h15a2 2 0 002-2V4a2 2 0 00-2-2H8zm1 2a1 1 0 00-1 1v22a1 1 0 001 1h13a1 1 0 001-1V5a1 1 0 00-1-1H9z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 11h2v1a2 2 0 01-2 2h-7a2 2 0 01-2-2v-1h2v1h7v-1zM19 6h2v1a2 2 0 01-2 2h-7a2 2 0 01-2-2V6h2v1h7V6zM19 17a1 1 0 112 0v2a1 1 0 11-2 0v-2z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesLockerFilled;